export default "__VITE_ASSET__NWdV9zwg__"